import { css, cx } from "styled-system/css";
import type { HTMLAttributes, ReactNode } from "react";

const card = css({
  bg: "bg.card",
  borderWidth: "1px",
  borderColor: "border.DEFAULT",
  rounded: "xl",
  p: "6",
  boxShadow: "0 10px 24px rgba(15, 23, 42, 0.06)",
  _dark: { boxShadow: "0 10px 24px rgba(2, 6, 23, 0.45)" },
});

export function Card({
  className,
  children,
  ...props
}: HTMLAttributes<HTMLDivElement> & { children: ReactNode }) {
  return (
    <div className={cx(card, className)} {...props}>
      {children}
    </div>
  );
}
